<template>
  <div class="register">
      <header-main></header-main>
      <nav-mobile></nav-mobile>
      <InfoPopup
        v-if="popup.visibility"
        :message="popup.message"
        @close="hidePopup"
      />
      <code-verification
        @logout="logout"
        @loggedIn="login"/>
      <section id="step2" class="order">
        <header class="main">
          <steps :step="2"></steps>
        </header>
          <step-2-log-and-nip
            v-if="logAndNipVisible"
            @goForward="logAndNipVisible = false, additionalDataVisible = true"
            @showPopup="showPopup"
          />
          <step-2-additional-data 
            v-if="additionalDataVisible"
            @goBack="additionalDataVisible = false, logAndNipVisible = true"
            @goForward="additionalDataVisible = false, registerAndRegulationsVisible = true"
            @showPopup="showPopup"
          />
          <step-2-register-and-regulations 
            v-if="registerAndRegulationsVisible"
            @goBack="registerAndRegulationsVisible = false, additionalDataVisible = true"
            @showPopup="showPopup"
          />
    </section>
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import NavMobile from '@/components/NavMobile.vue'
import FooterMain from '@/components/FooterMain.vue'
import OrderNav from '@/components/OrderNav.vue'
import Steps from '@/components/Steps.vue'
import CodeVerification from '@/components/CodeVerification.vue'
import Step2LogAndNip from '../components/Step2LogAndNip';
import Step2AdditionalData from '../components/Step2AdditionalData';
import Step2RegisterAndRegulations from '../components/Step2RegisterAndRegulations';
import validation from '../functions/validation';
import localStorageManager from '../functions/localStorageManager';
import InfoPopup from '../components/InfoPopup';

export default {
  name: 'Step2',
  components: {
    HeaderMain,
    NavMobile,
    FooterMain,
    OrderNav,
    Steps,
    CodeVerification,
    Step2LogAndNip,
    Step2AdditionalData,
    Step2RegisterAndRegulations,
    InfoPopup,
  },
  data() {
    return {
      fullValidation: false,
      logAndNipVisible: true,
      gusDataVisible: false,
      additionalDataVisible: false,
      registerAndRegulationsVisible: false,
      popup: {
        visibility: false,
        message: 'Test',

      },
    }
  },
  computed:{
    api(){
      return this.$store.state.api;
    },
    loggedIn() {
      return this.$store.state.loggedIn;
    },
  },
  watch:{
    logAndNipVisible() {
      this.storeInLocalStorage(this.logAndNipVisible, 'logAndNipVisible', 'step2State');
    },
    gusDataVisible() {
      this.storeInLocalStorage(this.gusDataVisible, 'gusDataVisible', 'step2State');
    },
    additionalDataVisible() {
      this.storeInLocalStorage(this.additionalDataVisible, 'additionalDataVisible', 'step2State');
    },
    registerAndRegulationsVisible() {
      this.storeInLocalStorage(this.registerAndRegulationsVisible, 'registerAndRegulationsVisible', 'step2State');
    },
    loggedIn() {
      
    },
  },
  methods:{
    logout() {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('formData');
      localStorage.removeItem('step2State');
      this.logAndNipVisible = true;
      this.gusDataVisible = false;
      this.additionalDataVisible = false;
      this.registerAndRegulationsVisible = false;
    },
    async login() {
      await this.axios
      .get(this.api + 'auth/token', { headers: { Authorization: localStorage.refreshToken } })
      .then(response => {
          if(response.data.status == 1) {
            localStorage.accessToken = response.data.accessToken;
            if(this.registerAndRegulationsVisible) {
              let step2State = JSON.parse(localStorage.step2State);
              step2State.haveAccount = 1;
              this.$store.commit('changeLoggedIn', 1);
              step2State.pickCompany = 1;
              localStorage.setItem('step2State', JSON.stringify(step2State));
              this.$store.commit('changeValidateStep', true);
              this.$router.push('/zamowienie/krok/3');
            } else {
              this.$store.commit('changeActivationCodeVerification', true);
            }
          } else {
            console.log(response);
          }
      });
    },
    storeInLocalStorage(value, valueName, objectName) {
      localStorageManager.storeInLocalStorage(value, valueName, objectName);
    },
    hidePopup() {
      this.popup.visibility = false;
    },
    showPopup(message) {
      this.popup.message = message;
      this.popup.visibility = true;
    }
  },
  mounted() {
    localStorage.setItem('formStep', 2);
    this.$store.commit('changeOrderNavDisable', true);
    if(localStorage.step2State !== undefined) {
        const step2State = JSON.parse(localStorage.step2State);
        Object.keys(step2State).forEach(key => {
            if(this[key] == '' || this[key]) {
                this[key] = step2State[key];
            }
        });
    }
  },
}
</script>

<style lang="scss">
  @import '../styles/step2Styles.scss';
</style>
